var PagedFilterAndSortedRequest = /** @class */ (function () {
    function PagedFilterAndSortedRequest() {
    }
    return PagedFilterAndSortedRequest;
}());
export default PagedFilterAndSortedRequest;
